/* Fadlen ürün sayfası (sections/fadlen-cx-main-product.liquid).
   Hollow hunt-socks davranışları: galeri (küçük resim, ok, kaydırma), beden tablosu aç/kapa,
   renk değişince varyant görseli, alt sabit çubuk.
   Varyant seçimi ve sepete ekleme Dawn'ın product-info / variant-selects / product-form öğelerinde. */
(() => {
  const init = (root) => {
    if (!root || root.dataset.fpdpReady) return;
    root.dataset.fpdpReady = 'true';
    const sectionId = root.dataset.section;

    /* Galeri */
    const gallery = root.querySelector('[data-fpdp-gallery]');
    const mainFrame = gallery?.querySelector('.ds-v2-pdp__main-image');
    const mainImage = gallery?.querySelector('.js-fpdp-main-image');
    const track = gallery?.querySelector('.ds-v2-pdp__thumb-track');
    const thumbs = gallery ? [...gallery.querySelectorAll('.js-fpdp-thumb')] : [];

    const showThumb = (thumb) => {
      if (!thumb || !mainImage) return;
      thumbs.forEach((button) => button.classList.toggle('is-active', button === thumb));
      mainImage.removeAttribute('srcset');
      mainImage.src = thumb.dataset.src;
      if (thumb.dataset.srcset) mainImage.srcset = thumb.dataset.srcset;
      mainImage.alt = thumb.dataset.alt || '';
      if (track) {
        const left = thumb.offsetLeft - (track.clientWidth - thumb.clientWidth) / 2;
        track.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    };
    const activeIndex = () => Math.max(0, thumbs.findIndex((button) => button.classList.contains('is-active')));
    const showOffset = (direction) => {
      if (!thumbs.length) return;
      showThumb(thumbs[(activeIndex() + direction + thumbs.length) % thumbs.length]);
    };
    const showMedia = (mediaId) => {
      const thumb = thumbs.find((button) => button.dataset.mediaId === String(mediaId));
      if (thumb) showThumb(thumb);
    };

    let gesture = null;
    mainFrame?.addEventListener('pointerdown', (event) => {
      if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
      gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, changed: false };
      if (event.pointerType === 'mouse') mainFrame.setPointerCapture?.(event.pointerId);
    });
    mainFrame?.addEventListener('pointermove', (event) => {
      if (!gesture || gesture.id !== event.pointerId || gesture.changed) return;
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      if (Math.abs(dx) < 28 || Math.abs(dx) <= Math.abs(dy) * 1.2) return;
      gesture.changed = true;
      mainFrame.classList.add('is-dragging');
      showOffset(dx < 0 ? 1 : -1);
    });
    const endGesture = () => {
      gesture = null;
      mainFrame?.classList.remove('is-dragging');
    };
    mainFrame?.addEventListener('pointerup', endGesture);
    mainFrame?.addEventListener('pointercancel', endGesture);

    /* Beden tablosu: panel variant-selects içinde, varyant değişince yeniden çiziliyor */
    let chartOpen = false;
    const applyChart = () => {
      const toggle = root.querySelector('.js-fpdp-chart-toggle');
      const panel = toggle && root.querySelector('#' + CSS.escape(toggle.dataset.chartTarget));
      if (!toggle || !panel) return;
      panel.hidden = !chartOpen;
      toggle.setAttribute('aria-expanded', String(chartOpen));
      toggle.textContent = chartOpen ? toggle.dataset.closeLabel : toggle.dataset.openLabel;
    };

    root.addEventListener('click', (event) => {
      const nav = event.target.closest('.js-fpdp-gallery-nav');
      if (nav) {
        showOffset(Number(nav.dataset.direction));
        return;
      }
      const thumb = event.target.closest('.js-fpdp-thumb');
      if (thumb) {
        showThumb(thumb);
        return;
      }
      if (event.target.closest('.js-fpdp-chart-toggle')) {
        event.preventDefault();
        chartOpen = !chartOpen;
        applyChart();
        return;
      }
      if (event.target.closest('.js-fpdp-sticky-button')) {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    /* Varyant değişimi (Dawn product-info yayını) */
    const stickyLabels = () => root.querySelectorAll('.js-fpdp-sticky-variants');
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (!data || data.sectionId !== sectionId) return;
        applyChart();
        const variant = data.variant;
        if (!variant) return;
        if (variant.featured_media) showMedia(variant.featured_media.id);
        const options = (variant.options || []).filter((value) => value && value !== 'Default Title');
        stickyLabels().forEach((label) => {
          label.textContent = options.length ? '(' + options.join(', ') + ')' : '';
        });
      });
    }

    /* Alt sabit çubuk: satın alma kutusu geçilince görünür, footer görününce gizlenir */
    const sticky = root.querySelector('.js-fpdp-sticky');
    if (sticky) {
      const trigger = () => root.querySelector('.ds-v2-pdp__cta-slot');
      const footer = document.querySelector('footer');
      const stickyButton = sticky.querySelector('.js-fpdp-sticky-button');
      const update = () => {
        const cta = trigger();
        const past = cta && cta.getBoundingClientRect().bottom < 0;
        const footerVisible = footer && footer.getBoundingClientRect().top <= window.innerHeight;
        const visible = Boolean(past && !footerVisible);
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', String(!visible));
        stickyButton?.setAttribute('tabindex', visible ? '0' : '-1');
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      requestAnimationFrame(update);
    }
  };

  const boot = () => document.querySelectorAll('product-info.ds-v2-pdp').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
